import { jsx as _jsx } from "react/jsx-runtime";
import { Calendar as PrimeCalendar } from 'primereact/calendar';
import { fromPickerDate, toPickerDate } from '@/shared/utils/app-timezone';
export function singleCalendarValue(value) {
    if (value == null)
        return null;
    if (value instanceof Date)
        return value;
    if (Array.isArray(value)) {
        const first = value.find((entry) => entry instanceof Date);
        return first ?? null;
    }
    return null;
}
/** PrimeReact Calendar that reads/writes datetimes in {@link APP_TIMEZONE} (Kabul). */
export function AppTimezoneCalendar({ value, onChange, ...rest }) {
    const pickerValue = Array.isArray(value)
        ? value.map((entry) => (entry instanceof Date ? toPickerDate(entry) : entry))
        : value instanceof Date
            ? toPickerDate(value)
            : value;
    return (_jsx(PrimeCalendar, { ...rest, value: pickerValue, onChange: (event) => {
            if (!onChange) {
                return;
            }
            const raw = event.value;
            if (raw == null) {
                onChange({ ...event, value: null });
                return;
            }
            if (Array.isArray(raw)) {
                onChange({
                    ...event,
                    value: raw.map((entry) => (entry instanceof Date ? fromPickerDate(entry) : entry)),
                });
                return;
            }
            onChange({
                ...event,
                value: raw instanceof Date ? fromPickerDate(raw) : raw,
            });
        } }));
}
